import { css } from 'linaria';
import { ShadowProps } from './';

export const root = css`
    display: inline-block;
    border-radius: 4px;
`;

export const rounded = css``;

export const sizes: Record<ShadowProps['size'], string> = {
    flat: css`
        border: 1px solid #e6e6e6;
    `,
    small: css`
        box-shadow: 0px 1px 1px -2px rgba(16, 16, 16, 0.2), 0px 2px 2px rgba(16, 16, 16, 0.14),
            0px 1px 5px rgba(16, 16, 16, 0.12);
    `,
    medium: css`
        box-shadow: 0px 3px 5px -1px rgba(16, 16, 16, 0.2), 0px 6px 10px rgba(16, 16, 16, 0.14),
            0px 1px 18px rgba(16, 16, 16, 0.12);
    `,
    large: css`
        box-shadow: 0px 7px 8px -4px rgba(16, 16, 16, 0.2), 0px 12px 17px 2px rgba(16, 16, 16, 0.14),
            0px 5px 22px 4px rgba(16, 16, 16, 0.12);
    `,
    'extra-large': css`
        box-shadow: 0px 11px 15px -7px rgba(16, 16, 16, 0.2), 0px 16px 38px 3px rgba(16, 16, 16, 0.14),
            0px 9px 46px 8px rgba(16, 16, 16, 0.12);
    `,
};
